import { Dialog } from '@ori-ui/components';
import { Gift } from '@ori-ui/icons';
import { paperClasses, styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  alignItems: 'center',
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(3),
  textAlign: 'center',
}));

export const GreetingMessageAndContact = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.grey[100],
  borderRadius: theme.spacing(1),
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2),
  width: '100%',
}));

export const Icon = styled(Gift)({
  height: 48,
  width: 48,
});

export const BannerDialog = styled(Dialog)(({ theme }) => ({
  [`& .${paperClasses.root}`]: {
    [theme.breakpoints.up('sm')]: {
      width: 390,
    },
  },
}));
